import { accessors } from '@yola/subscription-manager-js';

const getHostingAutoRenewStatus = () => {
  const hostingSubscription = accessors.getActiveHostingSubscription();
  return hostingSubscription?.auto_renew || false;
};

export default getHostingAutoRenewStatus;
